import React, { useState, useMemo } from 'react';
import { USER_GROUPS } from '../../../config/permissions';

function CreateUserModal({ isOpen, onClose, onSubmit }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [group, setGroup] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [comission, setComission] = useState('');
  const [description, setDescription] = useState('');

  const groupOptions = useMemo(() => {
    return Object.values(USER_GROUPS).filter(g => g !== USER_GROUPS.MASTER && g !== USER_GROUPS.ADMIN);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const groups = {};
    if (group) {
      const groupData = { display: group };
      if (group === USER_GROUPS.PROFISSIONAL) {
        groupData.comission = comission ? parseFloat(comission) : 0;
        groupData.description = description || '';
      }
      groups[group] = groupData;
    }
    const payload = {
      action: 'create',
      name,
      email,
      groups,
      comission,
      description
    };
    try {
      setIsSubmitting(true);
      await onSubmit(payload);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-elevated" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Novo usuário</h3>
          <button className="close" onClick={onClose}>×</button>
        </div>
        <form className="modal-body" onSubmit={handleSubmit}>
          <label>
            Nome
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
          </label>
          <label>
            E-mail
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label>
            Grupo
            <select value={group} onChange={(e) => setGroup(e.target.value)} required>
              <option value="">Selecione</option>
              {groupOptions.map(g => (
                <option key={g} value={g}>{g}</option>
              ))}
            </select>
          </label>
          {group === USER_GROUPS.PROFISSIONAL && (
            <>
              <label>
                Comissão %
                <input type="number" step="0.01" min="0" value={comission} onChange={(e) => setComission(e.target.value)} required />
              </label>
              <label>
                Descrição
                <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Dermatologista, Esteticista..." required />
              </label>
            </>
          )}
          <div className="modal-footer">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit" className="primary" disabled={isSubmitting}>{isSubmitting ? 'Criando...' : 'Criar'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CreateUserModal;


